import { ProcurementMethods } from 'services/tender';
import { IPaginatedData } from 'types/pagination';

export interface IContractItemFile {
  fileId: string;
  contractId: string;
  createdAt?: string;
  displayName?: string;
}

export enum EContractStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}

export interface IContractItem {
  id: string;
  lotId: string;
  contractorOrganizationId: string;
  issuerOrganizationId: string;
  amount: number | string;
  contractNumber: string;
  taxId: number;
  procurementMethod: ProcurementMethods
  createdAt: string;
  contractStartDate: string;
  contractEndDate: string;
  status: EContractStatus;
  tenderName: string;
  lotName: string;
  contractorOrganizationName: string;
  issuerOrganizationName: string;
  contractFiles: IContractItemFile[];
}

export type IContractsResponse = IPaginatedData<IContractItem>
